import { collections } from "/app/src/routes/{-$locale}/collections/index.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/collections/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import i18n from "@/lib/i18n";
import { getCollection } from "@/queries/collection";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/collections/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient,
      country
    } = context;
    await Promise.allSettled(collections.map(collection => queryClient.prefetchQuery({
      queryKey: ["collection", {
        slug: collection.slug,
        limit: 5,
        page: 1
      }],
      queryFn: () => getCollection({
        slug: collection.slug,
        limit: 5,
        page: 1,
        country: country ?? "US"
      }).catch(() => null)
    })));
    return {
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: () => {
    return {
      meta: [{
        title: i18n.t("collections.metaIndex.title"),
        description: i18n.t("collections.metaIndex.description")
      }, {
        name: "og:title",
        content: i18n.t("collections.metaIndex.title")
      }, {
        name: "og:description",
        content: i18n.t("collections.metaIndex.description")
      }, {
        name: "og:image",
        content: "https://cdn.egdata.app/placeholder-1080.webp"
      }, {
        name: "og:type",
        content: "website"
      }, {
        name: "twitter:title",
        content: i18n.t("collections.metaIndex.title")
      }, {
        name: "twitter:description",
        content: i18n.t("collections.metaIndex.description")
      }, {
        name: "twitter:image",
        content: "https://cdn.egdata.app/placeholder-1080.webp"
      }]
    };
  }
});